import { z } from 'zod';
import { TypeOfAPIError, TypeOfAPIResponse } from '@ninja/api-client';
import { APIFactoryOptions, factory } from '../../config';

const generateQuote = (options: APIFactoryOptions) =>
	factory(options).createAPIDefinition({
		url: 'Quote/generate',
		method: 'POST',
		responseSchema: z.object({
			totalAvailablePlans: z.number(),
			quoteReferenceNumber: z.string(),
		}),
		requestSchema: z.unknown().optional(),
		requestParameters: { encryptedQuoteJourneyId: ['required', 'string'] },
	});

export default generateQuote;

export type GenerateQuoteResponse = TypeOfAPIResponse<ReturnType<typeof generateQuote>>;

export type GenerateQuoteError = TypeOfAPIError<ReturnType<typeof generateQuote>>;
